import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { StarIcon } from '@heroicons/react/24/outline';
import { horoscopeService, HoroscopeEntry } from '../../services/horoscopeApi';

interface Props {
  sign: string | null;
}

const HoroscopoDoDiaCard: React.FC<Props> = ({ sign }) => {
  const navigate = useNavigate();
  const [horoscope, setHoroscope] = useState<HoroscopeEntry | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!sign) return;
    setLoading(true);
    setError(false);
    horoscopeService.getToday(sign)
      .then(setHoroscope)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [sign]);

  return (
    <div className="backdrop-blur-sm rounded-xl p-6 border border-white/20" style={{ background: 'rgba(255,255,255,0.05)' }}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <StarIcon className="w-6 h-6 text-gold-400" />
          <h3 className="text-lg font-semibold text-white">Horóscopo do Dia{sign ? ` — ${sign}` : ''}</h3>
        </div>
      </div>

      {loading ? (
        <p className="text-gray-400 text-sm">Consultando os astros…</p>
      ) : error ? (
        <p className="text-red-300 text-sm">Não foi possível carregar o horóscopo agora.</p>
      ) : horoscope ? (
        <p className="text-gray-300 text-sm leading-relaxed line-clamp-6 whitespace-pre-line">{horoscope.content}</p>
      ) : (
        <p className="text-gray-400 text-sm">Complete seus dados de nascimento para ver seu horóscopo personalizado.</p>
      )}

      <button
        onClick={() => navigate('/horoscope')}
        className="mt-4 text-xs font-semibold text-gold-400 hover:text-gold-300 transition-colors"
      >
        Ver horóscopo completo →
      </button>
    </div>
  );
};

export default HoroscopoDoDiaCard;
